var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoScritta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850.4 202.7",
    style: {
      enableBackground: "new 0 0 850.4 202.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.3,75v24.7H0v-98h27.7V75L73.3,75L73.3,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.6,86.6h-34.1l-5,13.1h-31.2l37.6-98h31.2l37.6,98h-31.2L175.6,86.6z M167.7,66.2l-9.1-23.8l-9.3,23.8 H167.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,1.7h36.5C319.8,1.7,344,22,344,50.6c0,28.7-24.3,49.1-58.5,49.1H249V1.7z M290.1,74.6 c14.8,0,25.4-10,25.4-24S305,26.8,290.1,26.8h-13.4v47.8L290.1,74.6L290.1,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413.7,26.4v11h46.6V62h-46.6v13h51.2v24.7H386v-98h78.9v24.7L413.7,26.4L413.7,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M564.3,99.7l-20.7-29.5H535v29.5h-27.7v-98h46.9c22,0,37.5,14.1,37.5,34.2c0,14-7.4,25-19.4,30.5l23.4,33.2 H564.3z M535,45.1h17c6.6,0,11.3-3.9,11.3-9.1s-4.7-9.1-11.3-9.1h-17V45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M697.2,86.6h-34.1l-5,13.1h-31.2l37.6-98h31.2l37.6,98h-31.2L697.2,86.6z M689.4,66.2l-9.1-23.8L671,66.2 H689.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M763.3,84.9l15.4-18.4c10,7.9,20.8,12,32.4,12c7.6,0,11.5-2.6,11.5-6.8c0-4.7-3.4-5.4-17-8.6 C784.4,58.2,768,52.6,768,32.2C768,12.7,783.4,0,806.6,0c17,0,30.2,4.6,41.1,13.3l-13.8,19.5c-9.1-6.6-19.1-9.8-27.9-9.8 c-6.7,0-10,2.7-10,6.4c0,5,3.4,6.6,17.4,9.6c22.8,4.9,37.1,11,37.1,29.7c0,20.7-15.8,32.8-40.4,32.8 C792.4,101.4,775.7,95.9,763.3,84.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.9,154.2h9.8l14.8,36.9l14.5-36.9h9.8l-20,47.4h-8.5L264.9,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M339.7,140.8c0-2.8,2.4-5.4,5.5-5.4c2.9,0,5.4,2.6,5.4,5.4c0,2.9-2.5,5.5-5.4,5.5 C342.1,146.3,339.7,143.7,339.7,140.8z M340.6,154.2h9.1v47.4h-9.1V154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.7,137.5v64.1h-9v-8.2c-3.7,5.9-9.5,9.3-16.9,9.3c-12.5,0-21.8-10.3-21.8-24.8c0-14.5,9.3-24.7,21.8-24.7 c7.3,0,13.2,3.5,16.9,9.3v-24.9H426.7z M417.7,177.8c0-9.9-6.1-16.9-14.7-16.9c-8.7,0-14.9,7-14.9,16.9c0,9.9,6.1,17,14.9,17 C411.5,194.8,417.7,187.7,417.7,177.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494,189.5l5.7,5.9c-4.2,4.5-12.5,7.3-19.2,7.3c-13.2,0-24.4-10.4-24.4-24.9c0-14.2,10.5-24.7,23.6-24.7 c14.5,0,22.8,11,22.8,28h-37.3c1.2,7.9,7,13.6,15.1,13.6C485.3,194.6,491.1,192.4,494,189.5z M465.4,173.8h28.4 c-1-7.3-5.5-12.7-13.7-12.7C472.8,161.1,466.8,166.1,465.4,173.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M528.9,177.8c0-13.5,11.5-24.7,25-24.7c13.5,0,24.9,11.3,24.9,24.7c0,13.5-11.4,24.8-24.9,24.8 C540.4,202.7,528.9,191.3,528.9,177.8z M569.7,177.8c0-9.2-7.2-16.9-15.8-16.9c-8.7,0-16,7.7-16,16.9c0,9.3,7.2,17,16,17 C562.5,194.8,569.7,187.1,569.7,177.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoScritta);
export default __webpack_public_path__ + "static/media/LOGO_SCRITTA.77878c7b1ab1eb53f502b765db92a60d.svg";
export { ForwardRef as ReactComponent };